export enum GenerationJobParsingMode {
  TABULAR = 'TABULAR',
  DEFAULT = 'DEFAULT',
  CITABLE = 'CITABLE',
}